import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Grid,
  Avatar,
} from "@mui/material";

const ViewTeamMemberModal = ({ open, handleClose, teamMember }) => {
  if (!teamMember) return null;

  const {
    firstName,
    lastName,
    email,
    phoneNumber,
    role,
    status,
    doctorTitle,
    doctorPreferredName,
    isPrimaryTrue,
    organizationName,
    photo,
  } = teamMember;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Team Member Details</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          {photo && (
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <Avatar
                src={photo}
                alt={`${firstName} ${lastName}`}
                sx={{ width: 80, height: 80, margin: "0 auto" }}
              />
            </Grid>
          )}
          <Grid item xs={6}>
            <Typography variant="subtitle2">First Name</Typography>
            <Typography>{firstName || "-"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Last Name</Typography>
            <Typography>{lastName || "-"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Email</Typography>
            <Typography>{email || "-"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Phone</Typography>
            <Typography>{phoneNumber || "-"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Role</Typography>
            <Typography>{role || "-"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Status</Typography>
            <Typography>{status || "-"}</Typography>
          </Grid>
          {role === "doctor" && (
            <>
              <Grid item xs={6}>
                <Typography variant="subtitle2">Title</Typography>
                <Typography>{doctorTitle || "-"}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2">Preferred Name</Typography>
                <Typography>{doctorPreferredName || "-"}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2">Primary Doctor</Typography>
                <Typography>{isPrimaryTrue ? "Yes" : "No"}</Typography>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <Typography variant="subtitle2">Organization</Typography>
            <Typography>{organizationName || "-"}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewTeamMemberModal;
